<template>
    <div class="abdo " id="abdoutus">
        <div class="row container-lg about ">
            <div class="col-lg-4 text--lg-end ">
                <img class="image  img-fluid"  src="../assets/about-left-image.png" alt="">
            </div>
            <div class="col-lg-8 right"   >
                <div class="row text-lg-start text-center">
                    <div class="col-lg-6 col-12  text-start d-flex justify-contect-between align-items-start itemm">
                        <div >
                            <img src="../assets/service-icon-01.png" alt="">
                        </div>
                        <div class="ms-3">
                            <h4>Data Analysis</h4>
                            <p>Lorem ipsum dolor sit amet, ctetur aoi adipiscing eliter</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12 text-start d-flex justify-contect-between align-items-start itemm">
                        <div >
                            <img  src="../assets/service-icon-02.png" alt="">
                        </div>
                        <div class="ms-3">
                            <h4 >Data Reporting</h4>
                            <p >Lorem ipsum dolor sit amet, ctetur aoi adipiscing eliter</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12 text-start d-flex justify-contect-between align-items-start itemm">
                        <div >
                            <img src="../assets/service-icon-03.png" alt="">
                        </div>
                        <div class="ms-3">
                            <h4>Web Analytics</h4>
                            <p>Lorem ipsum dolor sit amet, ctetur aoi adipiscing eliter</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12  text-start d-flex justify-contect-between align-items-start itemm">
                        <div>
                        <img src="../assets/service-icon-04.png" alt="">
                    </div>
                    <div class="ms-3">
                        <h4>SEO Suggestions</h4>
                        <p>Lorem ipsum dolor sit amet, ctetur aoi adipiscing eliter</p>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    name: "about",
    }
</script>

<style  scoped>
.abdo{
    background-image: url("../assets/about-bg.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        padding: 140px 0px 120px 0px;
        margin-top: 120px;
}

.right h4,
.right p{
    color: white;
}
.right h4{
    font-weight: 600
}
.right p {
    font-weight: 400;
    line-height: 1.6;
}
.right{
    padding-left:50px; 
    padding-top: 50px;
}

@media (max-width: 992px) {
    .itemm {
            background: linear-gradient(105deg, rgba(255, 77, 30, 1) 0%, rgba(255, 44, 109, 1) 100%);
            padding: 30px;
            border-radius: 20px;
            margin: 10px;
        }
        .abdo{
            background-image: none
        }
        .right{
            margin-left: auto;
            margin-right: auto;
            width: 90%
        }
        .right p {
            font-size: 16px;
        }
        .right h4{
            font-size: 18px;
        }
}
</style>